module.exports = __webpack_public_path__ + "static/media/AUXO-Horiz-fleet.6eddf2dd.png";